import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminLoginView from '../views/admin/AdminLoginView.vue'
import AdminView from '../views/admin/AdminView.vue'
import BracketManagerView from '../views/admin/BracketManagerView.vue'
import AdminJudgesView from '../views/admin/AdminJudgesView.vue'
import JudgeView from '../views/judge/JudgeView.vue'
import PublicBracketView from '../views/public/PublicBracketView.vue'
import PantallasListView from '../views/public/PantallasListView.vue'
import PublicPantallaView from '../views/public/PublicPantallaView.vue'
import { useAuth } from '../composables/useAuth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: AdminLoginView
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/torneo/:id',
    name: 'BracketManager',
    component: BracketManagerView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/jueces',
    name: 'AdminJudges',
    component: AdminJudgesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/jueces',
    name: 'Judge',
    component: JudgeView
  },
  {
    path: '/public',
    name: 'PublicBracket',
    component: PublicBracketView
  },
  {
    path: '/public/pantallas',
    name: 'PantallasList',
    component: PantallasListView
  },
  {
    path: '/public/pantalla/:torneoId/:categoriaId',
    name: 'PublicPantalla',
    component: PublicPantallaView
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Guard para proteger rutas de admin
router.beforeEach((to, from, next) => {
  const { isAdminLoggedIn } = useAuth()

  if (to.meta.requiresAuth && !isAdminLoggedIn.value) {
    next('/admin-login')
  } else {
    next()
  }
})

export default router
